module.exports = __webpack_public_path__ + "static/media/A0.eab6037d.svg";